module.exports.ucfirst = (Text)=>{
	return Text.charAt(0).toUpperCase() + Text.slice(1);
}

module.exports.ucwords = (Text)=>{
	return (Text + '').replace(/^(.)|\s+(.)/g, function ($1) {
		return $1.toUpperCase()
    })
}